import API from '@/api/api.js'
import Moment from 'moment';

export default class AdmAPIList {
  constructor() {
    console.debug('AdmAPI Created');
    let api = new API();
    this.api = api;
  }
  /**
   * Start of Second Class Api Management - Adm 
   */
  getDataList(parameters, success, error) {
    this.api.get('/entity', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }
  retrieveDataRecord(parameters, success, error) {
    this.api.get('/entity', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  createDataRecord(parameters, success, error) {
    this.api.post('/entity/create', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }
  deleteDataRecord(parameters, success, error) {
    this.api.post('/entity/delete', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }
  updateDataRecord(parameters, success, error) {
    this.api.post('/entity/edit', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }



  createAgent(parameters, success, error) {
    this.api.post('/agent/create', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }


  createProduct(parameters, success, error) {
    this.api.post('/product/create', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  editProduct(parameters, success, error) {
    this.api.post('/product/edit', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getProductList(parameters, success, error) {
    this.api.get('/product', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getProductDetail(parameters, success, error) {
    this.api.get('/product/detail', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  editAgent(parameters, success, error) {
    this.api.post('/agent/edit', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getAgentList(parameters, success, error) {
    this.api.get('/agent', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getAgentDetail(parameters, success, error) {
    this.api.get('/agent/detail', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getDocumentList(parameters, success, error) {
    this.api.get('/dm/document', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }
  deleteDocumentRecord(parameters, success, error) {
    this.api.post('/dm/document/delete', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getBulletinList(parameters, success, error) {
    this.api.get('/home/bulletin', parameters, (json) => {

      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getAuditTrailList(parameters, success, error) {
    this.api.get('/adm/auditTrail',
      parameters, (json) => {
        success(json);
      }, (err) => {
        error(err);
      },
      this.api.ParseTypeEnum.json);
  }

  getAuditTrailFunctionList(success, error) {
    this.api.get('/adm/auditTrail/types', {},
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      }, this.api.ParseTypeEnum.json);
  }

  getBulletinDetail(param, success, error) {
    this.api.get('/home/bulletin/detail', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  createBulletin(param, success, error) {
    this.api.post('/home/bulletin/create', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editBulletin(param, success, error) {
    this.api.post('/home/bulletin/edit', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteBulletin(param, success, error) {
    this.api.post('/home/bulletin/delete', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * User Authorization Management
   */
  getAuthorizationList(param, success, error) {
    this.api.get('/auth/role', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getAuthorizationOption(param, success, error) {
    this.api.get('/auth/role/option', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  grantOrRevokeAuthorization(param, success, error) {
    this.api.post('/auth/role/grantOrRevoke', param, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * Team Management
   */

  getTeamList(params, success, error) {
    this.api.get('/team', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createTeam(params, success, error) {
    this.api.post('/team/create', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editTeam(params, success, error) {
    this.api.post('/team/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  assignAgent(params, success, error) {
    this.api.post('/team/assign', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  resignAgent(params, success, error) {
    this.api.post('/team/resign', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getTeamDetail(params, success, error) {
    this.api.get('/team/detail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


  // 
  getTrainingList(params, success, error) {
    this.api.get('/training', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getAgentTrainingList(params, success, error) {
    this.api.get('/training/agent', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createTraining(params, success, error) {
    this.api.post('/training/create', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editTraining(params, success, error) {
    this.api.post('/training/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getTrainingDetail(params, success, error) {
    this.api.get('/training/detail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCompanyCommRecord(params, success, error) {
    this.api.get('/commission/policyCommission', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  payCompanyCommission(params, success, error) {
    this.api.post('/commission/payPolicyCommission', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getCommissionRecord(params, success, error) {
    this.api.get('/commission', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  payCommission(params, success, error) {
    this.api.post('/commission/pay', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getAgentTrainingDetail(params, success, error) {
    this.api.get('/training/agentDetail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getProviderOptions(params, success, error) {
    this.api.get('/provider/options', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Adm/apiList.js